/**
 * Returns the current URL path from `window.location`, including query string
 */
function getWindowPath() {
  return window.location.pathname + window.location.search;
}

module.exports = getWindowPath;




//////////////////
// WEBPACK FOOTER
// ./~/react-router/modules/helpers/getWindowPath.js
// module id = 194
// module chunks = 0